import { api } from "@/api/client";

export const billingApi = {
  plans: () => api.get("/billing/plans").then((r) => r.data),
  lifetimeSeats: () => api.get("/billing/lifetime-seats").then((r) => r.data),
  launchTier: () => api.get("/billing/launch-tier").then((r) => r.data),
  checkout: (payload) => api.post("/billing/checkout", payload).then((r) => r.data),
  checkoutStatus: (sid) => api.get(`/billing/checkout/status/${sid}`).then((r) => r.data),
  paypalConfig: () => api.get("/billing/paypal/config").then((r) => r.data),
  paypalCreateOrder: (lookup_key) => api.post("/billing/paypal/create-order", { lookup_key }).then((r) => r.data),
  paypalCaptureOrder: (order_id) => api.post("/billing/paypal/capture-order", { order_id }).then((r) => r.data),
  status: () => api.get("/billing/status").then((r) => r.data),
  precheck: (task) => api.post("/billing/precheck", { task }).then((r) => r.data),
  lifetimeOffer: () => api.get("/lifetime/offer").then((r) => r.data),
  lifetimeDismiss: () => api.post("/lifetime/dismiss").then((r) => r.data),
};
